import type {MachineEventObject} from './machine';

type PropsChangedEvent<TProps> = MachineEventObject & {
    type: 'PROPS_CHANGED';
    props: TProps;
    changes: ReadonlyArray<{key: keyof TProps}>;
};

const propsChangedEvent = <TProps>(event: MachineEventObject): PropsChangedEvent<TProps> | null => (
    event.type === 'PROPS_CHANGED' ? event as PropsChangedEvent<TProps> : null
);

const propsChanged = <TProps>(event: MachineEventObject, ...keys: Array<keyof TProps>): boolean => {
    const changed = propsChangedEvent<TProps>(event)?.changes;
    return changed?.some((change) => keys.includes(change.key)) ?? false;
};

export {propsChanged, propsChangedEvent};
export type {PropsChangedEvent};
